import React, { memo } from 'react';
import { Star, FileText } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';
import { PaneShell, PaneEmpty, PaneLink } from './PaneShell';

/**
 * ArtifactsPane — pinned files.
 *
 * Was a horizontal strip of 128px cards inside a full-width card, which meant a
 * pane the width of the screen could show six files while a scroll gesture
 * nobody expects hid the rest. A pane you can resize wants the opposite axis:
 * vertical rows use the width they're given and grow into the height you drag.
 */

function ArtifactsPaneImpl({ files, onPreview, onOpenFiles }) {
    return (
        <PaneShell
            icon={Star}
            label="Pinned"
            count={files.length}
            accent="text-yellow-500"
            action={<PaneLink onClick={onOpenFiles}>All files</PaneLink>}
        >
            {files.length === 0 ? (
                <PaneEmpty
                    icon={Star}
                    title="Nothing pinned"
                    hint="Star a file to keep it here"
                />
            ) : (
                <div className="cv-auto divide-y divide-white/[0.04]">
                    {files.map((file) => (
                        <button
                            key={file.id}
                            type="button"
                            onClick={() => onPreview(file)}
                            className="group flex w-full items-center gap-2.5 px-3 py-2 text-left transition-colors hover:bg-white/[0.03]"
                        >
                            <FileText className="h-3.5 w-3.5 flex-shrink-0 text-muted-foreground" />
                            <span className="min-w-0 flex-1 truncate font-mono text-xs transition-colors group-hover:text-primary">
                                {file.name}
                            </span>
                            {file.last_edited ? (
                                <span className="flex-shrink-0 whitespace-nowrap text-[10px] tabular-nums text-muted-foreground/70">
                                    {formatDistanceToNow(new Date(file.last_edited))}
                                </span>
                            ) : null}
                        </button>
                    ))}
                </div>
            )}
        </PaneShell>
    );
}

export const ArtifactsPane = memo(ArtifactsPaneImpl);
export default ArtifactsPane;
